import { Select } from 'antd'
import { Field, FieldProps } from 'formik'
import { CSSProperties } from 'styled-components'

type PerSelectProps = {
  name: string
  placeholder: string
  disabled?: boolean
  style?: CSSProperties
  children: React.ReactNode
} & { [key: string]: unknown }

export const FormikSelect = ({ name, placeholder, disabled, style, children, ...restProps }: PerSelectProps): JSX.Element => {
  return (
    <Field name={name}>
      {({ field: { value, name, onBlur }, form: { setFieldValue } }: FieldProps) => {
        return (
          <Select
            placeholder={placeholder}
            optionFilterProp="children"
            onChange={(value: string) => {
              setFieldValue(name, value)
            }}
            onBlur={(value) => {
              if (!!value && !!onBlur) {
                onBlur(value)
              }
            }}
            style={style}
            value={value || undefined}
            disabled={disabled}
            {...restProps}
          >
            {children}
          </Select>
        )
      }}
    </Field>
  )
}
